import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ComparisonTable from './components/ComparisonTable';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import SEOArticlesSection from './components/SEOArticlesSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuy.fit';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ComparisonTable />
        <CategoryGrid />
        <FAQSection />
        <ArticlePreviewSection />
        <SEOArticlesSection />
        <CTASection />
      </main>
      <Footer />

      {/* Breadcrumb Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Accueil',
                item: `${siteUrl}/`,
              },
            ],
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Hipobuy Spreadsheet',
            url: `${siteUrl}/`,
            description:
              'Guide complet Hipobuy Spreadsheet – Outils, comparatifs et automatisation de tableurs nouvelle génération.',
            inLanguage: 'fr',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `${siteUrl}/?q={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Hipobuy Spreadsheet',
            url: 'https://kaspreadsheet.com/',
            description:
              'Hipobuy Spreadsheet – L\'outil d\'automatisation de tableurs nouvelle génération. Guides, comparatifs et astuces pour optimiser votre productivité.',
            sameAs: [
              'https://kaspreadsheet.com/',
            ],
          }),
        }}
      />
    </>
  );
}